import { useHtmlDir } from '@aboutyou/legacy-shared/src/LegacyWebCoreConfigContext'
import { inject } from 'helpers/mobx'
import { useRouter } from 'helpers/navigation'
import React, { FC } from 'react'
import styled from 'styled-components'
import RoundButton from 'uiComponents/atoms/Buttons/RoundButton'
import { Icon, IconSize } from 'uiComponents/atoms/Icon/Icon'
import { IconName } from 'uiComponents/atoms/Icon/IconName'

const isExternalReferrer = (urlManagerStoreHistory: string[]): boolean => {
  if (typeof window === 'undefined' || urlManagerStoreHistory.length === 1) {
    return true
  }
  return window.history.length > 1 && urlManagerStoreHistory.length === 1
}

interface IBackButtonProps {
  externalReferer: boolean
  linkTo: string
}

const StyledRoundButton = styled(RoundButton)`
  display: flex;
  align-items: center;
  justify-content: center;
`

const StyledIcon = styled(Icon)<{ $isRTL: boolean }>`
  opacity: 0.4;
  margin-right: 4px;
  ${({ $isRTL }) => $isRTL && 'transform: scaleX(-1)'}
`

const BackButton: FC<IBackButtonProps> = ({ externalReferer, linkTo }) => {
  const { navigateClient } = useRouter()
  const onBackButtonClick = (event: React.MouseEvent<HTMLElement>) => {
    const isNewTab = window.history.length === 1
    if (!linkTo || isNewTab || externalReferer) {
      navigateClient(linkTo)(event)
      return
    }
    event.preventDefault()
    window.history.back()
  }

  const isRTL = useHtmlDir() === 'rtl'

  return (
    <a data-testid="BackButton" href={linkTo} onClick={onBackButtonClick}>
      <StyledRoundButton
        backgroundColor={'secondary'}
        data-testid="RoundBackButton"
      >
        <StyledIcon
          size={IconSize.XS}
          asset={IconName.IcChevronLeft}
          data-testid="BackButtonArrow"
          $isRTL={isRTL}
        />
      </StyledRoundButton>
    </a>
  )
}

export default inject(
  store => {
    const breadCrumbs = store.breadcrumbsStore.items
    const linkTo = (breadCrumbs[breadCrumbs.length - 1] || { url: '/' }).url

    return {
      externalReferer: isExternalReferrer(store.urlManagerStore.history),
      linkTo,
    }
  },
  {
    observe: true,
  },
)((props: IBackButtonProps) => <BackButton {...props} />)
